export default {
    template: `
        <option v-bind="$attrs">{{label}}</option>
    `,
    props:['translations'],
    computed:{
        label(){
            const topicTrans=this.translations.find(trans=>trans.language_code===window.lan)
            if(topicTrans){
                return topicTrans.name
            }
            return this.translations.find(trans=>trans.language_code==="en")?this.translations.find(trans=>trans.language_code==="en").name:''
        }
    }

};
